/* eslint-disable camelcase */
import { AddressesFormInputs } from '../components/Addresses/modal-addresses';
import React from 'react';

export enum CompanyIdentification {
  SA = 'SA',
  SRL = 'SRL',
  SAU = 'SAU',
  ACIV = 'ACIV',
  FUND = 'FUND',
  MUT = 'MUT',
  COOP = 'COOP',
  OP = 'OP',
  OTROS = 'OTROS',
}

export enum PhoneType {
  Mobile = 'MOBILE',
  Home = 'HOME',
  Work = 'WORK',
  Fax = 'FAX',
}

export enum AddressType {
  Legal = 'LEGAL',
  Mailing = 'MAILING',
}

export enum IdentificationTypes {
  DNI = 'DNI',
  CUIT = 'CUIT',
  CUIL = 'CUIL',
  SSN = 'SSN',
  TIN = 'TIN',
  SIN = 'SIN',
  NIN = 'NIN',
  PassportNumber = 'PASSPORT_NUMBER',
  DriversLicense = 'DRIVERS_LICENSE',
  BusinessNumber = 'BUSINESS_NUMBER',
  BusinessTaxId = 'BUSINESS_TAX_ID',
  TaxpayerReferece = 'TAXPAYER_REFERENCE',
}
export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Agender = 'AGENDER',
}

export enum GenderPatch {
  m = 'MALE',
  f = 'FEMALE',
  a = 'AGENDER',
}

// @TODO: move this
export enum CountryCode {
  AFG = 'AFG',
  ALB = 'ALB',
  DZA = 'DZA',
  AND = 'AND',
  AGO = 'AGO',
  ATG = 'ATG',
  ARG = 'ARG',
  ARM = 'ARM',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  BHS = 'BHS',
  BHR = 'BHR',
  BGD = 'BGD',
  BRB = 'BRB',
  BLR = 'BLR',
  BEL = 'BEL',
  BLZ = 'BLZ',
  BEN = 'BEN',
  BTN = 'BTN',
  BOL = 'BOL',
  BIH = 'BIH',
  BWA = 'BWA',
  BRA = 'BRA',
  BRN = 'BRN',
  BGR = 'BGR',
  BFA = 'BFA',
  BDI = 'BDI',
  CIV = 'CIV',
  HRV = 'HRV',
  CUB = 'CUB',
  CYP = 'CYP',
  CZE = 'CZE',
  DNK = 'DNK',
  DJI = 'DJI',
  DMA = 'DMA',
  DOM = 'DOM',
  TLS = 'TLS', // Timor-Leste
  ECU = 'ECU',
  EGY = 'EGY',
  SLV = 'SLV',
  GNQ = 'GNQ',
  ERI = 'ERI',
  EST = 'EST',
  SWZ = 'SWZ',
  ETH = 'ETH',
  FJI = 'FJI',
  FIN = 'FIN',
  FRA = 'FRA',
  GAB = 'GAB',
  GMB = 'GMB',
  GEO = 'GEO',
  DEU = 'DEU',
  GHA = 'GHA',
  GRC = 'GRC',
  GRD = 'GRD',
  GTM = 'GTM',
  GIN = 'GIN',
  GNB = 'GNB',
  GUY = 'GUY',
  HTI = 'HTI',
  HND = 'HND',
  HUN = 'HUN',
  ISL = 'ISL',
  IND = 'IND',
  IDN = 'IDN',
  IRN = 'IRN',
  IRQ = 'IRQ',
  IRL = 'IRL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JPN = 'JPN',
  JOR = 'JOR',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KIR = 'KIR',
  PRK = 'PRK',
  KOR = 'KOR',
  KWT = 'KWT',
  KGZ = 'KGZ',
  LAO = 'LAO',
  LVA = 'LVA',
  LBN = 'LBN',
  LSO = 'LSO',
  LBR = 'LBR',
  LBY = 'LBY',
  LIE = 'LIE',
  LTU = 'LTU',
  LUX = 'LUX',
  MKD = 'MKD',
  MDG = 'MDG',
  MWI = 'MWI',
  MYS = 'MYS',
  MDV = 'MDV',
  MLI = 'MLI',
  MLT = 'MLT',
  MHL = 'MHL',
  MRT = 'MRT',
  MUS = 'MUS',
  MEX = 'MEX',
  FSM = 'FSM',
  MDA = 'MDA',
  MCO = 'MCO',
  MNG = 'MNG',
  MNE = 'MNE',
  MAR = 'MAR',
  MOZ = 'MOZ',
  MMR = 'MMR',
  NAM = 'NAM',
  NRU = 'NRU',
  NPL = 'NPL',
  NLD = 'NLD',
  NZL = 'NZL',
  NIC = 'NIC',
  NER = 'NER',
  NGA = 'NGA',
  NOR = 'NOR',
  OMN = 'OMN',
  PAK = 'PAK',
  PLW = 'PLW',
  PAN = 'PAN',
  PNG = 'PNG',
  PRY = 'PRY',
  PER = 'PER',
  PHL = 'PHL',
  POL = 'POL',
  PRT = 'PRT',
  QAT = 'QAT',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  KNA = 'KNA',
  LCA = 'LCA',
  VCT = 'VCT',
  WSM = 'WSM',
  SMR = 'SMR',
  STP = 'STP',
  SAU = 'SAU',
  SEN = 'SEN',
  SRB = 'SRB',
  SYC = 'SYC',
  SLE = 'SLE',
  SGP = 'SGP',
  SVK = 'SVK',
  SVN = 'SVN',
  SLB = 'SLB',
  SOM = 'SOM',
  ZAF = 'ZAF',
  SSD = 'SSD',
  ESP = 'ESP',
  LKA = 'LKA',
  SDN = 'SDN',
  SSD = 'SSD',
  SUR = 'SUR',
  SWE = 'SWE',
  CHE = 'CHE',
  SYR = 'SYR',
  TWN = 'TWN',
  TJK = 'TJK',
  TZA = 'TZA',
  THA = 'THA',
  TGO = 'TGO',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TKM = 'TKM',
  TUV = 'TUV',
  UGA = 'UGA',
  UKR = 'UKR',
  ARE = 'ARE',
  GBR = 'GBR',
  USA = 'USA',
  URY = 'URY',
  UZB = 'UZB',
  VUT = 'VUT',
  VEN = 'VEN',
  VNM = 'VNM',
  YEM = 'YEM',
  ZMB = 'ZMB',
  ZWE = 'ZWE',
}

export enum CardHolderType {
  Person = 'PERSON',
  Holder = 'HOLDER',
  Company = 'COMPANY',
}

interface ICard {
  id: string;
  card_product_id: string;
  card_type: string; // TODO: create enum with types of cards
  sequence_number: string;
  last_four: string;
  state: string; // TODO: create enum with card states
  state_reason: string;
  account: {
    currency: string;
    account_id: string;
  }[];
  cardholder_id: string;
  ownership_level: string;
  cardholder_parent: string;
  card_parent: string;
  created_time: string;
}

interface IPhone {
  type: string;
  number: string;
  country: string;
  area_code: string;
}

export interface IAddress {
  type: string;
  street: string;
  street_number: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  floor: string;
  apt: string;
}

export interface IIdentification {
  type: string;
  number: string;
  country: string;
  registered_vat_payer: boolean;
}

export interface ICardHolder {
  id: string;
  type: CardHolderType;
  centralized_balance: boolean;
  active: string;
  state: string; // TODO: create enum with states
  first_name: string;
  last_name: string;
  legal_name: string;
  birth_date: string;
  gender: string; // TODO: create enum with gender
  email: string;
  nationality: string;
  external_id: string;
  created_time: string;
  last_modified_time: string;
  identifications: IIdentification[];
  addresses: IAddress[];
  phones: IPhone[];
  cards: ICard[];
  inscription_date: string;
  trade_name: string;
  additional_info: {
    type: string;
    value: string;
  };
}

type CommonCardHolderPost = {
  type: CardHolderType;
  centralized_balance: boolean;
  email: string;
  nationality: CountryCode;
  external_id?: string;
  identifications: any[];
  phones: any[];
  addresses: any[];
};

type CardHolderCompanyPost = {
  legal_name?: string;
  trade_name?: string;
  inscription_date?: string;
  identification_type?: CompanyIdentification;
};

type CardHolderPersonPost = {
  first_name?: string;
  last_name?: string;
  birth_date?: string;
  gender: Gender;
};

//TODO dividir en compañia/persona
export type CardHolderPut = {
  first_name: string;
  last_name: string;
  email: string;
  nationality: string
  birth_date: string;
  gender: Gender;
  phones: any[];
  identifications: any[];
  addresses: any[];
}

export type CardHolderPost = CommonCardHolderPost & (CardHolderCompanyPost | CardHolderPersonPost);